import AppCard from '@crema/core/AppCard';
import AppScrollbar from '@crema/core/AppScrollbar';
import { ArrowBack, Person } from '@mui/icons-material';
import {
  Divider,
  Grid,
  Stack,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Avatar,
  Chip,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MediaViewer from 'shared/components/MediaViewer';
import { getFileSize } from '@crema/utility/Utils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonContained, ButtonOutlined } from 'shared/components/Button';
import { COLORS } from 'shared/constants/AppEnums';
import {
  onApproveDocumentDigisign,
  onPutDocumentPkReturn,
  onPutDocumentPkCancel,
  onGetDetailDigisign,
  onChangeFilter
} from 'redux/actions/DigitalSign';
import { useSelector } from 'react-redux';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';
import { useAuthMethod, useAuthUser } from '@crema/utility/AuthHooks';
import LogHistory from '../../Components/LogHistory';
import DialogSignDetail from '../../Dialog/DialogSignDetail';

// Tertiary color, same as the "Tolak" button on Dokumen Lain
const tolakButtonSx = {
  background: '#d2b48c !important',
  '&:hover': { background: '#a58b67 !important' },
};

const DetailDokumen = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [index, setIndex] = useState(-1);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [logs, setLogs] = useState([]);
  const [modalConfApprove, setModalConfApprove] = useState(false);
  const [modalConfReturn, setModalConfReturn] = useState(false);
  const [modalConfSign, setModalConfSign] = useState(false);
  const [modalConfReject, setModalConfReject] = useState(false);
  const [openSignDialog, setOpenSignDialog] = useState(false);
  const [stateDialog, setStateDialog] = useState({
    passphrase: '',
    isBypass: true,
  });
  const [errorDialog, setErrorDialog] = useState({ passphrase: false });
  const { user } = useAuthUser();
  const { setUser } = useAuthMethod();
  const hasBypassRole = user?.roles_coofis?.some(
    (item) => item.state === 'BYPASS_PASSPHRASE',
  );
  const { id } = useParams();
  const { pathname, search } = useLocation();
  const [approverRole, setApproverRole] = useState(false);
  const [releaseRole, setReleaseRole] = useState(false);
  const { profileMe } = useSelector((state) => state.profile);
  const { detail, filter } = useSelector((state) => state.digiSign);
  const [monitoringRole, setMonitoringRole] = useState(false);
  const hasCancelRole = profileMe?.roles_coofis?.some(
    (item) => item.state === 'CANCEL_PK',
  );
  const queryParams = new URLSearchParams(search)

  const approveCheck = (sequence, index, isPenanda = false) => {
    if (sequence <= index) {
      return (
        <>
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '10px',
              backgroundColor: COLORS.primary,
            }}
          >
            <CloseIcon sx={{ fontSize: '10px', color: '#fff' }} />
          </Stack>
          <Chip
            label={
              isPenanda ? 'Belum Ditandatangan' : 'Belum Disetujui'
            }
            style={{
              backgroundColor: COLORS.secondary,
            }}
            sx={{
              color: COLORS.primary,
            }}
            size='small'
          />
        </>
      );
    } else if (sequence > index) {
      return (
        <>
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '10px',
              backgroundColor: '#11C15B',
            }}
          >
            <CheckIcon sx={{ fontSize: '10px', color: '#fff' }} />
          </Stack>
          <Chip
            label={isPenanda ? 'Ditandangani' : 'Disetujui'}
            style={{
              backgroundColor: '#D9F5E5',
            }}
            sx={{
              color: '#11C15B',
            }}
            size='small'
          />
        </>
      );
    }
  };

  useEffect(() => {
    if (id !== undefined && pathname === '/apps/dokumen-pk/detail/' + id) {
      let filterParam = queryParams.get('filter')
      if (filterParam) {
        dispatch(onChangeFilter(filterParam))
      }
      dispatch(onGetDetailDigisign(id, monitoringRole ? true : false));
    }
  }, [id]);

  const handleApprove = () => {
    let data = {
      passphrase: 'approve',
      id_documents: [detail.id],
      sign_date: moment().format('DD MMMM YYYY'),
    };
    dispatch(onApproveDocumentDigisign(data, () => navigation(`/apps/dokumen-pk`)));
  };

  const handleReturnDoc = () => {
    let data = {
      id_documents: [detail.id],
      comment: '',
    };
    dispatch(onPutDocumentPkReturn(data, () => navigation(`/apps/dokumen-pk`)));
  };

  const handleCancelDoc = () => {
    let data = {
      id_documents: [detail.id],
      comment: '',
    };
    dispatch(onPutDocumentPkCancel(data, () => navigation(`/apps/dokumen-pk`)));
  };

  // Passphrase already saved (bypass) -> confirmation only, otherwise ask for passphrase
  const handleSign = () => {
    if (user?.is_bypass) setModalConfSign(true);
    else setOpenSignDialog(true);
  };

  const submitSign = (passphrase, isBypass) => {
    let data = {
      passphrase: passphrase,
      id_documents: [detail.id],
      sign_date: moment().format('DD MMMM YYYY'),
      is_bypass: isBypass ? 'true' : 'false',
    };
    dispatch(
      onApproveDocumentDigisign(
        data,
        () => {
          setUser({ ...user, is_bypass: isBypass });
          navigation(`/apps/dokumen-pk`);
        },
        () => {
          setUser({ ...user, is_bypass: false });
        },
      ),
    );
  };

  const handleCloseSignDialog = () => {
    setStateDialog({ passphrase: '', isBypass: true });
    setErrorDialog({ passphrase: false });
    setOpenSignDialog(false);
  };

  const handleSubmitSignDialog = () => {
    if (stateDialog.passphrase === '') {
      setErrorDialog({ passphrase: true });
      return;
    }
    submitSign(stateDialog.passphrase, hasBypassRole && stateDialog.isBypass);
    handleCloseSignDialog();
  };

  useEffect(() => {
    if (profileMe) {
      const monitoringRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'MONITORING_DIGITAL_SIGN',
        ) > -1
          ? true
          : false;

      const tmpApproverRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'APPROVER.DIGISIGN.PK',
        ) > -1
          ? true
          : false;
      const tmpReleaseRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'RELEASE.DIGISIGN.PK',
        ) > -1
          ? true
          : false;

      setReleaseRole(tmpReleaseRole);
      setApproverRole(tmpApproverRole);
      setMonitoringRole(monitoringRole);
    }
  }, [profileMe]);

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleShowAttachment = (index) => {
    setIndex(index);
  };

  const onCloseShowAttachment = () => {
    setIndex(-1);
  };

  const openPDF = (data) => {
    const iframe = document.querySelector('#iframePkDetail');
    const wrapper = document.querySelector('#wrapperIframe');
    if (iframe) {
      wrapper.appendChild(iframe);

      const applyStylesAndOpen = () => {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        const style = iframeDoc.createElement('style');
        style.textContent = `
                    #editorModeButtons #editorFreeText,
                    #editorModeButtons #editorInk,
                    #editorModeButtons #editorStamp {
                        display: none !important;
                    }
                `;
        iframeDoc.head.appendChild(style);

        iframe.contentWindow?.PDFViewerApplication.open(data);
      };

      if (iframe.contentWindow?.PDFViewerApplication?.initialized) {
        applyStylesAndOpen();
      } else {
        iframe.onload = applyStylesAndOpen;
      }
    }
  };

  useEffect(() => {
    if (detail) {
      const filteredData = detail?.logs.filter(
        (item) => item.action === 'approve',
      );
      detail?.attachments.map((item) => {
        setUploadedFiles({
          name: item.name,
          type: getFileExtension(item.name),
          size: item.file_size,
        });
      });

      filteredData.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      const distinctApproves = {};
      filteredData.forEach((item) => {
        if (!distinctApproves[item.user]) {
          distinctApproves[item.user] = item;
        }
      });
      setLogs(Object.values(distinctApproves).reverse());

      if (detail.attachments?.length > 0) {
        openPDF(detail.attachments[0].file);
      }
    }
  }, [detail]);

  return detail !== null ? (
    <>
      <Stack spacing={4}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={9}>
            <Stack spacing={4}>
              <AppCard sxStyle={{ backgroundColor: 'white !important' }}>
                <Stack spacing={2}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box>
                      <Tooltip title={'Kembali'} placement='top' arrow>
                        <IconButton onClick={() => navigation(-1)}>
                          <ArrowBack />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    <Stack direction='row' spacing={2}>
                      {(detail?.state === 'need_sign' &&
                        detail?.authors?.includes(profileMe?.nip)) && (
                          <>
                            <ButtonContained variant='contained' onClick={handleSign}>
                              Proses Tanda Tangan
                            </ButtonContained>
                            <ButtonContained
                              variant='contained'
                              sx={tolakButtonSx}
                              onClick={() => setModalConfReturn(true)}
                            >
                              Tolak
                            </ButtonContained>
                          </>
                        )}
                      {detail?.state === 'need_approval' && detail?.authors?.includes(profileMe?.nip) && (
                        <>
                          <ButtonContained
                            variant='contained'
                            onClick={() => setModalConfApprove(true)}
                          >
                            Setuju
                          </ButtonContained>
                          <ButtonContained
                            variant='contained'
                            sx={tolakButtonSx}
                            onClick={() => setModalConfReturn(true)}
                          >
                            Tolak
                          </ButtonContained>
                        </>
                      )}
                      {detail?.state === 'done' && hasCancelRole && (
                        <ButtonContained
                          variant='contained'
                          onClick={() => setModalConfReject(true)}
                        >
                          Batalkan
                        </ButtonContained>
                      )}
                      <ButtonOutlined
                        variant='outlined'
                        onClick={() => navigation(-1)}
                      >
                        Tutup
                      </ButtonOutlined>
                    </Stack>
                  </Box>

                  <Divider />

                  <Stack spacing={5} paddingTop={5}>
                    <Typography
                      variant='h1'
                      color={'primary.default'}
                      component='div'
                      textTransform={'capitalize'}
                    >
                      {detail?.subject}
                    </Typography>

                    <Grid container rowSpacing={4}>
                      <Grid item xs={5} sm={3}>
                        <Typography fontWeight={'bold'}>No Dokumen</Typography>
                      </Grid>
                      <Grid item xs={7} sm={9}>
                        <Typography>{detail?.extra_attributes?.noDokumen}</Typography>
                      </Grid>

                      <Grid item xs={5} sm={3}>
                        <Typography fontWeight={'bold'}>Operator</Typography>
                      </Grid>
                      <Grid container item xs={7} sm={9}>
                        <Grid item xs={6}>
                          <Stack direction='row' alignItems={'center'} spacing={4}>
                            <Avatar
                              src={
                                detail?.composer?.composer_avatar ||
                                detail?.composer?.avatar_url
                              }
                              sx={{
                                width: { xs: '40px', md: '50px' },
                                height: { xs: '40px', md: '50px' },
                              }}
                            ></Avatar>

                            <Stack spacing={1}>
                              <Typography
                                variant='h3'
                                fontSize={{ xs: 12, md: 18 }}
                                fontWeight={'bold'}
                              >
                                {detail?.composer?.is_title
                                  ? detail?.composer?.officer?.nama
                                  : detail?.composer?.nama}
                              </Typography>
                              <Typography
                                fontSize={{ xs: 12, md: 18 }}
                                sx={{ color: (theme) => theme.palette.text.disabled }}
                              >
                                {detail?.composer?.is_title
                                  ? detail?.composer?.display_title
                                  : null}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid item xs={5} sm={3}>
                        <Typography fontWeight={'bold'}>
                          Tanggal Dokumen Dibuat
                        </Typography>
                      </Grid>
                      <Grid item xs={7} sm={9}>
                        <Typography>
                          {moment(detail?.extra_attributes?.tanggalDokumen).format(
                            'DD MMMM YYYY',
                          )}
                        </Typography>
                      </Grid>

                      <Grid item xs={5} sm={3}>
                        <Typography fontWeight={'bold'}>Jabatan PPPK</Typography>
                      </Grid>
                      <Grid item xs={7} sm={9}>
                        <Typography>
                          {detail?.extra_attributes?.tugas}
                        </Typography>
                      </Grid>

                      <Grid item xs={5} sm={3}>
                        <Typography fontWeight={'bold'}>Status</Typography>
                      </Grid>
                      <Grid item xs={7} sm={9}>
                        <Typography>
                          {detail?.extra_attributes?.status}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Stack>
              </AppCard>

              <Stack>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <AppCard sxStyle={{ backgroundColor: 'white !important', height: 200 }} contentStyle={{ padding: '0 !important' }}>
                      <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                        <Stack paddingX={'24px'}>
                          <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                            Penerima
                          </Typography>
                        </Stack>

                        <Stack height={'100%'} position={'relative'}>
                          {detail?.receivers?.length > 0 ? (
                            <Stack position={'absolute'} width={'100%'} height={'100%'}>
                              <AppScrollbar>
                                <Stack paddingX={'24px'}>
                                  <Grid container spacing={4}>
                                    {
                                      detail?.receivers?.map((item, index) => (
                                        <Grid item xs={12} md={12} key={index}>
                                          <Stack spacing={2}>
                                            <Stack spacing={2}>
                                              <Stack direction='row' alignItems={'center'} spacing={2}>
                                                <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '20px', md: '30px' }, height: { xs: '20px', md: '30px' } }}>
                                                  <Person sx={{ fontSize: '24px' }} />
                                                </Avatar>

                                                <Stack spacing={1}>
                                                  {item.is_title ? (
                                                    <>
                                                      <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                      <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                    </>
                                                  )}
                                                </Stack>
                                              </Stack>
                                            </Stack>
                                          </Stack>
                                        </Grid>
                                      ))
                                    }
                                  </Grid>
                                </Stack>
                              </AppScrollbar>
                            </Stack>
                          ) : (
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                              <Typography>Tidak ada data</Typography>
                            </Stack>
                          )}
                        </Stack>
                      </Stack>
                    </AppCard>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <AppCard sxStyle={{ backgroundColor: 'white !important', height: 200 }} contentStyle={{ padding: '0 !important' }}>
                      <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                        <Stack paddingX={'24px'}>
                          <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                            Tembusan
                          </Typography>
                        </Stack>

                        <Stack height={'100%'} position={'relative'}>
                          {detail?.tembusans !== null && (Array.isArray(detail?.tembusans) && detail?.tembusans.length) > 0 ? (
                            <Stack position={'absolute'} width={'100%'} height={'100%'}>
                              <AppScrollbar>
                                <Stack paddingX={'24px'}>
                                  <Grid container spacing={4}>
                                    {
                                      detail?.tembusans?.map((item, index) => (
                                        <Grid item xs={12} md={12} key={index}>
                                          <Stack spacing={2}>
                                            <Stack spacing={2}>
                                              <Stack direction='row' alignItems={'center'} spacing={2}>
                                                <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '20px', md: '30px' }, height: { xs: '20px', md: '30px' } }}>
                                                  <Person sx={{ fontSize: '24px' }} />
                                                </Avatar>

                                                <Stack spacing={1}>
                                                  {item.is_title ? (
                                                    <>
                                                      <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                      <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Typography variant='h3' fontSize={{ xs: 12, md: 14 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                    </>
                                                  )}
                                                </Stack>
                                              </Stack>
                                            </Stack>
                                          </Stack>
                                        </Grid>
                                      ))
                                    }
                                  </Grid>
                                </Stack>
                              </AppScrollbar>
                            </Stack>
                          ) : (
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                              <Typography>Tidak ada data</Typography>
                            </Stack>
                          )}
                        </Stack>
                      </Stack>
                    </AppCard>
                  </Grid>
                </Grid>
              </Stack>

              <AppCard sxStyle={{ backgroundColor: 'white !important' }}>
                <Stack spacing={4}>
                  <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                    Dokumen
                  </Typography>

                  <Stack id='wrapperIframe' height={'100vh'}>
                    <iframe src='/assets/latest-pdfjs-dist/web/viewer.html' id='iframePkDetail' style={{ height: '100%', border: 0 }} />
                  </Stack>
                </Stack>
              </AppCard>
            </Stack>
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack spacing={4} height={'100%'}>
              <Stack height={{ xs: '400px', md: '100%' }}>
                <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100%' }} contentStyle={{ padding: '0 !important' }}>
                  <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                    <Stack paddingX={'24px'}>
                      <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                        Penanggung Jawab
                      </Typography>
                    </Stack>

                    <Stack height={'100%'} position={'relative'}>
                      <Stack position={'absolute'} width={'100%'} height={'100%'}>
                        <AppScrollbar>
                          <Stack paddingX={'24px'}>
                            <Grid container spacing={4}>
                              {
                                detail?.approvers?.map((item, index) => (
                                  index !== 0 ? (
                                    <Grid item xs={12} md={12} key={index}>
                                      <Stack spacing={4}>
                                        <Stack spacing={2}>
                                          <Stack direction='row' alignItems={'center'} spacing={4}>
                                            <Avatar src={item?.avatar_url || item?.composer_avatar} sx={{ width: { xs: '30px', md: '40px' }, height: { xs: '30x', md: '40px' } }}>
                                              <Person sx={{ fontSize: '28px' }} />
                                            </Avatar>

                                            <Stack spacing={1}>
                                              {index === 1 ? (
                                                <Typography variant='h6'>
                                                  Penandatangan 1
                                                </Typography>
                                              ) : detail.approvers.length == index + 1 ? (
                                                <Typography variant='h6'>
                                                  Penandatangan 2
                                                </Typography>
                                              ) : (
                                                <Typography variant='h6'>
                                                  Persetujuan {index - 1}
                                                </Typography>
                                              )}

                                              {item.is_title ? (
                                                <>
                                                  <Typography variant='h3' fontSize={{ xs: 12, md: 16 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : '-'}</Typography>
                                                  <Typography fontSize={{ xs: 11, md: 14 }} sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography>
                                                </>
                                              ) : (
                                                <>
                                                  <Typography variant='h3' fontSize={{ xs: 12, md: 16 }} fontWeight={'bold'}>{item?.is_title ? item?.display_title : item?.nama}</Typography>
                                                </>
                                              )}

                                              {logs && logs[index - 1] !== undefined && detail?.sequence > index && (
                                                <Typography variant='h6' component={'span'} color={'GrayText'}>
                                                  {
                                                    index === 1 || detail.approvers.length == index + 1
                                                      ? 'Ditandatangani'
                                                      : 'Disetujui'
                                                  }
                                                  :{' '}
                                                  {moment(
                                                    logs[index - 1].created_at,
                                                  ).format('DD MMMM YYYY || HH:mm')}
                                                </Typography>
                                              )}

                                              <Stack direction={'row'} alignItems={'center'} gap={1}>
                                                {approveCheck(
                                                  detail?.sequence,
                                                  index,
                                                  index === 1 || detail.approvers.length == index + 1,
                                                )}
                                              </Stack>
                                            </Stack>
                                          </Stack>
                                        </Stack>

                                        <Divider orientation='horizontal' flexItem />
                                      </Stack>
                                    </Grid>
                                  ) : null
                                ))
                              }
                            </Grid>
                          </Stack>
                        </AppScrollbar>
                      </Stack>
                    </Stack>
                  </Stack>
                </AppCard>
              </Stack>

              <Stack height={{ xs: '400px', md: '100%' }}>
                <AppCard sxStyle={{ backgroundColor: 'white !important', height: '100%' }} contentStyle={{ padding: '0 !important' }}>
                  <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                    <Stack paddingX={'24px'}>
                      <Typography variant='h3' fontWeight={'bold'} color={'primary.default'} component='div' textTransform={'capitalize'}>
                        Riwayat Aktivitas
                      </Typography>
                    </Stack>

                    <Stack height={'100%'} position={'relative'}>
                      <Stack position={'absolute'} width={'100%'} height={'100%'}>
                        <AppScrollbar>
                          <Stack paddingX={'24px'}>
                            <LogHistory data={detail?.logs} />
                          </Stack>
                        </AppScrollbar>
                      </Stack>
                    </Stack>
                  </Stack>
                </AppCard>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Stack>

      {index >= 0 ? (
        <MediaViewer
          index={index}
          medias={{
            url: detail.attachments[index].file,
            mime_type: uploadedFiles.type,
            name: uploadedFiles.name,
            size: getFileSize(uploadedFiles.size),
          }}
          onClose={onCloseShowAttachment}
        />
      ) : null}
      <AppConfirmDialog
        open={modalConfApprove}
        onDeny={() => {
          setModalConfApprove(false);
        }}
        onConfirm={() => {
          setModalConfApprove(false);
          handleApprove();
        }}
        title={'Apakah anda yakin akan menyetujui dokumen pk ini ' + '?'}
        dialogTitle={'Approve PK'}
      />
      <AppConfirmDialog
        open={modalConfReturn}
        onDeny={() => {
          setModalConfReturn(false);
        }}
        onConfirm={() => {
          setModalConfReturn(false);
          handleReturnDoc();
        }}
        title={'Apakah anda yakin akan menolak dokumen pk ini ' + '?'}
        dialogTitle={'Tolak PK'}
      />
      <AppConfirmDialog
        open={modalConfReject}
        onDeny={() => {
          setModalConfReject(false);
        }}
        onConfirm={() => {
          setModalConfReject(false);
          handleCancelDoc();
        }}
        title={'Apakah anda yakin akan membatalkan dokumen pk ini ' + '?'}
        dialogTitle={'Batalkan PK'}
      />
      <AppConfirmDialog
        open={modalConfSign}
        onDeny={() => {
          setModalConfSign(false);
        }}
        onConfirm={() => {
          setModalConfSign(false);
          submitSign('', true);
        }}
        title={'Apakah anda yakin akan menandatangani dokumen pk ini ' + '?'}
        dialogTitle={'Tanda Tangan PK'}
      />
      <DialogSignDetail
        open={openSignDialog}
        title={'Form Tanda Tangan'}
        state={stateDialog}
        error={errorDialog}
        onChangeState={(name, value) =>
          setStateDialog((prev) => ({ ...prev, [name]: value }))
        }
        handleClose={handleCloseSignDialog}
        handleSubmit={handleSubmitSignDialog}
      />
    </>
  ) : null;
};

export default DetailDokumen;
